import { render, staticRenderFns } from "./ImsImage.vue?vue&type=template&id=28b7fc99"
import script from "./ImsImage.vue?vue&type=script&lang=js"
export * from "./ImsImage.vue?vue&type=script&lang=js"
import style0 from "./ImsImage.vue?vue&type=style&index=0&id=28b7fc99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports